import { render, staticRenderFns } from "./DeletePrivilegeGroup.vue?vue&type=template&id=d2b8d40e"
import script from "./DeletePrivilegeGroup.vue?vue&type=script&lang=js"
export * from "./DeletePrivilegeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports